import OperatorService from "@/api/services/operator.service";

const ClientService = {
  getList(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/clients`, { headers: params });
  },

  getListForShare(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/clients-for-share`, { headers: params });
  },

  get(id) {
    return OperatorService.get(`/clients/${id}`);
  },

  delete(id) {
    return OperatorService.delete(`/clients/${id}`);
  },

  update(id, newClient) {
    return OperatorService.put(`/clients/${id}`, newClient);
  },

  getFbs(id) {
    return OperatorService.get(`/clients/${id}/fbs`);
  },

  updateFbs(id, is_fbs) {
    return OperatorService.put(`/clients/${id}/fbs`, { mode: is_fbs });
  },

  getCameras(id, show_deleted_cameras = false) {
    return OperatorService.get(`/clients/${id}/cameras`, { headers: {
      show_deleted_cameras: show_deleted_cameras ? 1 : 0
    }});
  },

  getSharedCameras(id) {
    return OperatorService.get(`/clients/${id}/shared-cameras`);
  },

  getClientIntercoms(id) {
    return OperatorService.get(`/clients/${id}/intercom-bindings`);
  },

  getClientIntercomsAvailable(id, params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/clients/${id}/intercom-bindings/available`, { headers: params });
  },

  createClientIntercom(id, newClientIntercom) {
    return OperatorService.post(`/clients/${id}/intercom-bindings`, newClientIntercom);
  },

  deleteClientIntercom(id, idIntercom) {
    return OperatorService.delete(`/clients/${id}/intercom-bindings/${idIntercom}`)
  },

  create(newClient) {
    return OperatorService.post(`/clients`, newClient);
  },

  createClientsMass(clients) {
    return OperatorService.post(`/clients/mass-create`, clients)
  }
};

export default ClientService;
